<template>
  <div id="country-content" class="country-content">
    <img
      v-if="!smallscreen"
      :src="`${$baseUrl}images/${imagePath}.webp`"
      alt=""
      class="country-content__img"
    />

    <div class="country-content__content-wrapper">
      <InterviewContent
        class="country-content__content"
        :title="title"
        :content="content"
        :withScrollbar="false"
      />
    </div>

    <CountryModalFooter
      :projectAmount="projectAmount"
      :currentProjectIndex="currentProjectIndex"
      @onNavigate="$emit('onNavigate', $event)"
    />
  </div>
</template>

<script setup>
import { inject } from "vue";

import InterviewContent from "./InterviewContent.vue";
import CountryModalFooter from "./CountryModalFooter.vue";

defineProps({
  countryCode: String,
  title: String,
  imagePath: String,
  content: Object,
  projectAmount: Number,
  currentProjectIndex: Number,
  smallscreen: Boolean,
});

const $baseUrl = inject("$baseUrl");
</script>

<style lang="scss" scoped>
.country-content {
  --footer-height: #{toRem(71)};
  --padding-top: 40%;

  position: relative;

  &__img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 50%;
    object-fit: cover;
  }

  &__content-wrapper {
    position: relative;
    z-index: 1;

    .desktop &,
    .large & {
      padding: var(--padding-top) 7vw 0;
      height: calc(100% - var(--footer-height));
      overflow: auto;
    }

    .country-content__content {
      padding: 0;
      overflow: initial;

      .desktop &,
      .large & {
        height: calc(100% - var(--padding-top));
      }

      ::v-deep(.interview-content__inner) {
        background-color: var(--white-100);

        .desktop &,
        .large & {
          padding: 2.5rem;
          border: 1px solid var(--page-color);
          border-bottom: none;
        }

        .mobile &,
        .tablet & {
          padding: 2.5rem var(--page-padding-h);
        }
      }
    }
  }
}
</style>
